import React from "react";
import { Link } from "react-router-dom";
import { BRAND_NAME } from "../../config/brand";

const AuthBrand: React.FC<{ compact?: boolean }> = ({ compact }) => {
  return (
    <Link
      to="/"
      className={`group inline-flex items-center gap-3 ${
        compact ? "" : "mb-8"
      }`}
    >
      <div className="relative">
        <div className="size-12 rounded-2xl flex items-center justify-center ">
          <img src="/assets/rentBhaiLogo.svg" alt={`${BRAND_NAME} Logo`} className="w-10 h-10" />

        </div>
        <div className="absolute inset-0 rounded-2xl bg-gradient-to-tr from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
      </div>
      <span className="text-2xl font-extrabold tracking-tight bg-gradient-to-r from-gray-900 via-primary-700 to-purple-700 dark:from-white dark:via-primary-300 dark:to-purple-300 bg-clip-text text-transparent">
        {BRAND_NAME}
      </span>
    </Link>
  );
};

export default AuthBrand;
